import React from 'react';
import FormInput from 'components/Input/FormInput';

export const ArticleNumberInput: React.FC = React.memo(() => {
	return (
		<FormInput
			testId="ArticleNumberInput"
			name="articleNumber"
			label="articleNumberLabel"
			maxLength={100}
			disabled={true}
		/>
	);
});
